






































































import { computed, ref, defineComponent, PropType, onMounted, onUnmounted, watch } from '@vue/composition-api';
import { Message } from '@/layout/type';
import iconArrow from 'assets/images/ai/icon.png';
import iconArrowActive from 'assets/images/ai/icon_active.png';
import { AI_MODEL_LIST, AIFunctionType } from '@/const/business';
import { getDoctorInfo, deepClone } from '@/utils/utils';
interface SelectOption {
  value: string;
  label: string;
}
export default defineComponent({
  props: {
    message: {
      type: Object as PropType<Message>,
      default: () => ({
        timestamp: 0,
        role: 'patient',
        text: '',
      }),
    },
    templateText: {
      type: String,
      default: '',
    },
    isTyping: Boolean,
    isActive: {
      type: String as PropType<AIFunctionType>,
    },
    type: String,
    name: String,
    patientTags: Array,
    tag: Array,
    planType: String,
    aiModelType: String,
  },
  setup(props, { emit, root }: any) {
    const editorRef: any = ref(null);

    const onSend = () => {
      const content = editorRef.value.innerText;
      emit('send', content);
      editorRef.value.innerText = '';
    };
    const isEmpty = ref(true);

    const isEditorShow = computed(() => props.isActive
        && !props.isTyping
        && (props.name
          || (props.type !== 'patient'
            && props.isActive !== AIFunctionType.healthReport
            && props.isActive !== AIFunctionType.healthRecord))
        && (props.tag?.length
          || props.type !== 'label'
          || props.isActive === AIFunctionType.healthReport
          || props.isActive === AIFunctionType.healthRecord));
    const formattedContent = computed(() => {
      let content = props.templateText;
      // 使用正则表达式匹配 {$variable#placeholder} 和 {$[array]#placeholder}
      content = content?.replace(/\{\$(\w+|\[\w+\])#(.*?)\}/g, (match, variable, placeholder) => {
        // 处理数组变量
        if (variable.startsWith('[') && variable.endsWith(']')) {
          const arrayName = variable.slice(1, -1);
          const arrayValue = props[arrayName];
          if (Array.isArray(arrayValue) && arrayValue.length) {
            return arrayValue.map(item => `<span class="blue node">${item}</span>`).join(', ');
          }
          return `<span class="grey node" data-placeholder="${placeholder}" >${placeholder}</span>`;
        }

        // 处理普通变量

        let value = props[variable];

        if (variable === 'planType' && value === '自定义') value = '';

        if (value) {
          return `<span class="blue node">${value}</span>`;
        }
        return `<span class="grey node" data-placeholder="${placeholder}" >${placeholder}</span>`;
      });

      return content;
    });
    watch(formattedContent, (newValue) => {
      if (!newValue) isEmpty.value = true;
      else isEmpty.value = false;
    });
    const onInput = (event) => {
      const target = event.target;

      if (target.innerText.trim() === '') {
        isEmpty.value = true;
      } else isEmpty.value = false;
    };

    const onblur = () => {
      if (editorRef.value.innerText.trim() === '') {
        isEmpty.value = true;
      }
      const spans = editorRef.value.querySelectorAll('span.waiting');
      spans.forEach((span) => {
        if (span.textContent.trim() === '') {
          span.classList.remove('blue');
          span.classList.add('grey');
          span.classList.remove('waiting');
          span.textContent = span.getAttribute('data-placeholder');
        }
      });
    };

    const onclick = (event) => {
      // 查找点击的元素
      // console.log(event.target);
      onblur();

      const target = event.target;

      // 检查点击的元素是否是类名为 grey 的 span
      if (target.classList.contains('grey')) {
        target.classList.remove('grey');
        target.classList.add('blue');
        target.classList.add('waiting');
        // 清空元素内容
        target.textContent = '    ';
        const selection = window.getSelection();
        setTimeout(() => {
          const newRange = document.createRange();
          newRange.setStart(target, 1);
          newRange.setEnd(target, 1);
          selection?.removeAllRanges();
          selection?.addRange(newRange);
        }, 0);
      }
    };
    const onKeydown = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        onSend();
      }
    };

    const doctorInfo = ref<any>({});
    const computedAIModel = computed(() => {
      const doctorInfoValue = doctorInfo.value;
      const { isActive = '' } = props;
      const dataMap = {
        [AIFunctionType.healthReport]: {
          show: 'aiSummaryAssistant',
          content: 'aiSummaryAssistantModel',
        },
        [AIFunctionType.healthEducation]: {
          show: 'aiEducationAssistant',
          content: 'aiEducationAssistantModel',
        },
        [AIFunctionType.healthPlan]: {
          show: 'aiPlanAssistant',
          content: 'aiPlanAssistantModel',
        },
        [AIFunctionType.healthRecord]: {
          show: 'aiPatientArchiveChatAssistant',
          content: 'aiPatientArchiveChatAssistantModel',
        },
      };
      const list: SelectOption[] = [];
      if (doctorInfoValue?.[dataMap[isActive]?.show] === 'Y') {
        const options = JSON.parse(doctorInfoValue?.[dataMap[isActive].content]) || [];
        options.forEach((item) => {
          const target = AI_MODEL_LIST.find(AIItem => AIItem.value === item);
          if (target) list.push(deepClone(target));
        });
        if (list.length === 1) {
          emit('update:aiModelType', list[0].value);
        }
        return list;
      }
      return '';
    });

    const modelSelectShow = ref(false);
    const handleAiModel = () => {
      modelSelectShow.value = !modelSelectShow.value;
    };

    const selectMode = (aiModeType: string) => {
      emit('update:aiModelType', aiModeType);
      modelSelectShow.value = false;
    };

    const modelSwitchRef = ref<HTMLElement | null>(null);
    // 点击外部关闭下拉菜单
    const handleClickOutside = (event: MouseEvent) => {
      if (modelSelectShow.value && modelSwitchRef.value && !modelSwitchRef.value.contains(event.target as Node)) {
        modelSelectShow.value = false;
      }
    };

    // 添加全局点击事件监听
    onMounted(async () => {
      doctorInfo.value = await getDoctorInfo();
      document.addEventListener('click', handleClickOutside);
    });

    // 移除事件监听
    onUnmounted(() => {
      document.removeEventListener('click', handleClickOutside);
    });

    return {
      formattedContent,
      editorRef,
      isEditorShow,
      onSend,
      onclick,
      onblur,
      onInput,
      onKeydown,
      modelSelectShow,
      selectMode,
      iconArrow,
      iconArrowActive,
      modelSwitchRef,
      handleAiModel,
      AIFunctionType,
      computedAIModel,
      AI_MODEL_LIST,
      isEmpty,
    };
  },
});
